import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, FormControl, InputLabel, Select, MenuItem, Stack,
  Typography, Box
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import BookIcon from '@mui/icons-material/Book';

const SubjectEditDialog = ({ open, subject, onClose, onSave, availableTeachers = [] }) => {
  const [formData, setFormData] = useState({
    name: '',
    teacher: '',
    hours_per_week: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (subject) {
      setFormData({
        name: subject.name || '',
        teacher: subject.teacher || '',
        hours_per_week: subject.hours_per_week || ''
      });
      setErrors({});
    }
  }, [subject]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear error for this field
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'اسم المادة مطلوب';
    }
    if (formData.hours_per_week && (isNaN(formData.hours_per_week) || formData.hours_per_week < 0)) {
      newErrors.hours_per_week = 'يجب أن يكون عدد الساعات رقم صحيح موجب';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    const updatedData = {
      name: formData.name.trim(),
      hours_per_week: formData.hours_per_week ? parseInt(formData.hours_per_week) : null
    };

    if (formData.teacher) {
      updatedData.teacher = formData.teacher;
    } else {
      updatedData.teacher = null;
    }

    onSave(updatedData);
  };


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, direction: 'rtl' }
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
          color: 'white',
          textAlign: 'center',
          py: 2
        }}
      >
        <Stack useFlexGap direction="row" spacing={2} alignItems="center" justifyContent="center">
          <EditIcon />
          <Typography variant="h6" fontWeight="bold">
            تعديل المادة
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            label="اسم المادة"
            value={formData.name}
            onChange={handleChange('name')}
            error={!!errors.name}
            helperText={errors.name}
            required
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />

          <TextField
            fullWidth
            label="الساعات الأسبوعية"
            type="number"
            value={formData.hours_per_week}
            onChange={handleChange('hours_per_week')}
            error={!!errors.hours_per_week}
            helperText={errors.hours_per_week}
            inputProps={{ min: 0 }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />

          <FormControl fullWidth>
            <InputLabel>المعلم (اختياري)</InputLabel>
            <Select
              value={formData.teacher}
              onChange={handleChange('teacher')}
              label="المعلم (اختياري)"
              sx={{ borderRadius: 2 }}
            >
              <MenuItem value="">لا يوجد</MenuItem>
              {availableTeachers.map((teacher) => (
                <MenuItem key={teacher.id} value={teacher.id}>
                  {teacher.first_name} {teacher.last_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ minWidth: 100, borderRadius: 2 }}
        >
          إلغاء
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{ minWidth: 100, borderRadius: 2 }}
        >
          حفظ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectEditDialog;
